const TeachersArray = [
  {
    id: 12,
    name: "Bukola",
    imgURL: "../../resources/school/portraits/Bukola.jpg",
    aboutMeText: `I am Bukola, an enthusiastic English teacher dedicated to helping children and adults achieve their language goals.
    Through clear explanations and interactive lessons, I help students gain the confidence to use English naturally in daily life, education, and the workplace.`,
  },
  {
    id: 0,
    name: "Alicja Marciniak",
    imgURL: "../resources/school/portraits/AlicjaMarciniak2.jpg",
    aboutMeText: `Ukończyłam podypolomowe studia Dydaktyki i Nauczania Języka Angielskiego przy Wyższej Szkole
    Języków Obcych im.Samuela Linde w Poznaniu.

    Po studiach wyjechalam do Wielkiej Brytanii gdzie pracowalam poczatkowo jako pomocnik nauczyciela oraz w
    fundacji Aiming High, gdzie pomagalam dzieciom niepełnosprawnym fizycznie lub umysłowo. Ewentualnie zdobyłam
    kwalifikacje CELTA (angielski ekwiwalent nauczyciela dyplomowanego) zaoferowano mi pozycję EAL - tutor.

    W Wielkiej Brytanii zdobyłam równiez praktykę w tłumaczeniach pisemnych i ustnych z języka angielskiego na polski
    i vice versa; pracowałam dla policji, NHS (odpowiednik polskiego NFZ) i służb socjalnych; zdobyłam uprawnienia community
    language interpreter(tłumacz społecznościowy).

    Przez kolejne kilka lat pracowałam jako nauczyciel indywidualny wspierający naukę angielskiego dzieci i młodzieży z
    różnych krajów świata. W 2018 roku wróciłam do Polski i rozpoczęłam szkołę Extra English.`,
  },
  {
    id: 7,
    name: "Joy Emezuo",
    imgURL: "../../resources/school/portraits/JoyEmezuo.jpg",
    aboutMeText: `Nazywam się Joy Emezuo, jestem zmotywowaną, entuzjastyczną, zaradną i oddaną nauczycielką języka angielskiego oraz
    solidnie zaangażowaną w rozwój społeczny i akademicki każdego dziecka. Mam doświadczenie w nauczaniu indywidualnym / grupowym, a moim
    celem jest zachęcanie do twórczej ekspresji, rozwiązywania problemów i budowania poczucia własnej wartości uczniów za pomocą różnych stylów uczenia.

    My name is Joy Emezuo, I am a highly motivated, enthusiastic, resourceful and dedicated English Language instructor with a solid
    commitment to the social and academic growth and development of every child. I am experienced in one-on-one tutoring/ group instruction
    and my goal driven towards encouraging creative expression, problem solving and building of student self esteem with diverse learning styles.`,
  },
  {
    id: 1,
    name: "Jan Pęchorzewski",
    imgURL: "../../resources/school/portraits/JanekPechorzewskiSquare.jpg",
    aboutMeText: `Mam na imię Janek i jestem osobą przyjazną oraz kreatywną, posiadam także doświadczenie w pracy z dziećmi.

    Język angielski towarzyszy mi od zawsze. Pochłonął mnie on jednak podczas pierwszej wycieczki do Wielkiej Brytanii.
    Po tej wycieczce postanowiłem zagłębić się zarówno w kulturę oraz język tego kraju. Stawiam na rozwój zarówno moich podopiecznych jak i siebie.`,
  },
  {
    id: 9,
    name: "Zuzanna Adamek",
    imgURL: "../../resources/school/portraits/ZuzannaAdamek.jpg",
    aboutMeText: `Jestem osobą pozytywnie nastawioną do życia, cierpliwą i pełną energii. Bardzo lubię pracę z dziećmi i czerpię
    z niej dużo radości. Wiem, że każde dziecko jest inne, dlatego staram się podchodzić do każdego ucznia indywidualnie i dostosowywać
    sposób prowadzenia zajęć do jego potrzeb oraz możliwości.

    Język angielski jest moją pasją, dlatego z przyjemnością dzielę się swoją wiedzą z najmłodszymi. Zależy mi na tym, aby dzieci
    nie tylko poznawały nowe słówka i zwroty, ale przede wszystkim dobrze się bawiły i nabierały pewności siebie w posługiwaniu się językiem.
    Wierzę, że nauka poprzez zabawę, ruch i ciekawe aktywności sprawia, że wiedza zostaje z dziećmi na dłużej.

    Praca w Extra English pozwala mi połączyć zamiłowanie do języka angielskiego z ogromną sympatią do dzieci. Największą satysfakcję
    daje mi obserwowanie ich postępów, zaangażowania i uśmiechu podczas zajęć. Staram się tworzyć atmosferę, w której każde dziecko czuje się
    swobodnie, bezpiecznie i chętnie podejmuje nowe wyzwania.`,
  },
  {
    id: 11,
    name: "Eryk Smoleń",
    imgURL: "../../resources/school/portraits/ErykSmolen.jpg",
    aboutMeText: `Jestem studentem piątego roku filologii angielskiej. Język angielski towarzyszy mi od dzieciństwa,
    a dziś z przyjemnością dzielę się swoją wiedzą i pasją z innymi.

    W nauczaniu zależy mi na jasnym, przystępnym wyjaśnianiu zagadnień oraz wspieraniu uczniów w osiąganiu ich celów.
    Najwięcej satysfakcji daje mi obserwowanie ich postępów i rosnącej pewności siebie w posługiwaniu się językiem.

    Interesuję się przede wszystkim informatyką i grami komputerowymi. Moją największą pasją są gry wyścigowe,
    szczególnie seria Need for Speed. Od kilku lat fascynują mnie także Stany Zjednoczone i Kanada — kraje, które chciałbym
    w przyszłości odwiedzić. Jestem osobą ambitną i konsekwentną, dlatego zawsze staram się wytrwale dążyć do celu.`,
  },
  {
    id: 13,
    name: "Mateusz Woźniak",
    imgURL: "../../resources/school/portraits/MateuszWozniak.png",
    aboutMeText: `Jestem studentem drugiego roku międzynarodowych stosunków gospodarczych na Uniwersytecie Ekonomicznym w Poznaniu.
    Na co dzień jestem osobą przyjazną, ambitną i otwartą na nowych ludzi oraz wyzwania.

    Język niemiecki towarzyszy mi od najmłodszych lat i jest moją pasją. Chcę pokazać innym, że wcale nie jest taki straszny,
    jak się wydaje. W nauczaniu stawiam przede wszystkim na dialog oraz konkretne, treściwe zajęcia. Ogromną satysfakcję
    daje mi obserwowanie postępów moich uczniów i rozwoju ich umiejętności językowych.

    Moją wielką pasją jest sport, szczególnie gry zespołowe i treningi na siłowni. Wolne chwile najchętniej spędzam
    w gronie przyjaciół. Uwielbiam też podróżować, odkrywać nowe miejsca i poznawać inne kultury.
    Bardzo cenię rozwój osobisty i ciągłe poszerzanie własnych horyzontów.`,
  },
];

export const ArchivedTeachers = [
  {
    id: 10,
    name: "Alicja Kostka",
    imgURL: "../../resources/school/portraits/AlicjaKostka.jpg",
    aboutMeText: `Jestem osobą bardzo otwartą i pozytywną. Uwielbiam podróżować, poznawać nowe kultury i zawierać nowe znajomości.
    Od dzieciństwa towarzyszył mi język angielski. Uczęszczałam do międzynarodowej szkoły podstawowej i gimnazjum International School
    of Poznań, w której językiem wykładowym był angielski.

    Zawsze interesowała mnie kultura anglosaska i chciałam zamieszkać w USA lub Australii. Moi nauczyciele powtarzali, żebym zapisała się
    na wymianę do kraju, w którym pierwszym językiem jest angielski. Miałam okazję wyjechać do USA w ramach programu Amicus prowadzonego
    przez fundację Young Life. Był to rok spędzony w amerykańskiej szkole i amerykańskiej rodzinie.

    Lubię przebywać z małymi dziećmi. Już od kilku lat miałam okazję dorywczo pracować przy opiece nad dziećmi. Będąc w Stanach Zjednoczonych,
    pracowałam w ramach Sunday School Teacher Assistance z dziećmi w wieku przedszkolnym i wczesnoszkolnym. Uwielbiałam moją pracę,
    a dzieci zawsze miały dużo energii.`,
  },
  {
    id: 5,
    name: "Ania Mąkowska",
    imgURL: "../../resources/school/portraits/AniaMakowska.png",
    aboutMeText: `Jestem bardzo przyjazną i energetyczną osobą. Uwielbiam spędzać czas z dziećmi i przekazywać im swoją wiedzę.

    Języka angielskiego (poza edukacją w szkole i na prywatnych lekcjach) uczyłam się podczas wielu wyjazdów, wymian uczniowskich
    czy spotkań z osobami zza granicy. Nauka tego języka zawsze sprawiała mi przyjemność.

    Swoje doświadczenia przekładam na tworzenie zajęć w Extra English. Bardzo lubię wymyślać zabawy i gry, dzięki czemu lekcje są
    merytoryczne ale zarazem ciekawe.`,
  },
  {
    id: 6,
    name: "Faith Ndebelle",
    imgURL: "../../resources/school/portraits/FaithNdebelle.jpg",
    aboutMeText: `My name is Faith, and I come from Africa. I'm a native English speaker, love children, enjoy spending time with
    them, teaching them is a joy for me. I am very patient, and always eager to meet new people, learn more about their culture and
    make them feel loved and appreciated. I enjoy learning and teaching.

    Nazywam się Faith i pochodzę z Afryki. Jestem native speakerem języka angielskiego, kocham dzieci, lubię spędzać z nimi czas, uczenie
    ich jest dla mnie radością. Jestem bardzo cierpliwa i zawsze chętna do poznawania nowych ludzi, poznawania ich kultury i sprawiania,
    by czuli się kochani i doceniani. Lubię się uczyć i uczyć innych.`,
  },
  {
    id: 8,
    name: "Ashlyn Martin",
    imgURL: "../../resources/school/portraits/AshlynMartin.jpg",
    aboutMeText: `Cześć, nazywam się Ashlyn Martin i jestem native speakerką języka angielskiego oraz doświadczonym instruktorem TEFL (Teaching English as a Foreign Language).
    Skupiam się na interaktywnym nauczaniu skoncentrowanym na uczniu i pracuję z uczniami z całego świata, aby rozwijać ich umiejętności językowe, poprawiać
    umiejętności komunikacyjne i budować ich pewność siebie. Wykorzystuję kombinację angażujących ćwiczeń, rzeczywistych przykładów i spersonalizowanej informacji
    zwrotnej, pomagając moim uczniom osiągnąć ich cele językowe i odnieść sukces w dzisiejszym zglobalizowanym świecie.

    Hi there, my name is Ashlyn Martin, and I'm a native English speaker and experienced TEFL (Teaching English as a Foreign Language)
    instructor. With a focus on interactive, student-centered teaching, I work with students from all over the world to develop their language skills,
    improve their communication abilities, and build their confidence. Using a combination of engaging activities, real-world examples, and personalized
    feedback, I help my students to achieve their language goals and succeed in today's globalized world.`,
  },
];

export default TeachersArray;
